import React from 'react';
import { useNavigate } from 'react-router-dom';

// Prices aligned to RAW hair bundle table (smallest length price per texture)
const hairImages = [
  { src: '/hairs/photo1.jpg', alt: 'Hair Style 1', title: 'Straight Extensions',      price: 'from R1 250' }, // 10" Straight/Bodywave = R1250
  { src: '/hairs/photo2.jpg', alt: 'Hair Style 2', title: 'Bodywave Bundles',        price: 'from R1 250' }, // same band
  { src: '/hairs/photo3.jpg', alt: 'Hair Style 3', title: 'Deepwave / Waterwave',    price: 'from R1 350' }, // 10" Deepwave = R1350
  { src: '/hairs/photo4.jpg', alt: 'Hair Style 4', title: 'Cambodian Wavy',          price: 'from R1 350' }, // 10" Cambodian = R1350
  { src: '/hairs/photo5.jpg', alt: 'Hair Style 5', title: 'Indian Curly',            price: 'from R1 350' }, // 10" Indian Curly = R1350
  { src: '/hairs/photo6.jpg', alt: 'Hair Style 6', title: 'Burmese Curls',           price: 'from R1 350' }, // 10" Burmese = R1350
  { src: '/hairs/photo7.jpg', alt: 'Hair Style 7', title: '4B/4C Afro Kinks',        price: 'from R1 350' }, // 10" 4B/4C = R1350
  { src: '/hairs/photo8.jpg', alt: 'Hair Style 8', title: 'Kinky Straight',          price: 'from R1 250' }, // align with Straight band
  { src: '/hairs/photo0.jpg', alt: 'Hair Style 9', title: 'Yaki Texture',            price: 'from R1 250' }, // align with Straight band
];

const HairShowcaseSection = () => {
  const navigate = useNavigate();

  return (
    <section
      className="py-4"
      style={{
        textAlign: 'center',
        margin: '2rem auto 1.2rem auto',
        padding: '1.1rem 0.6rem',
        background: '#fffdfa',
        borderRadius: 14,
        boxShadow: '0 2px 9px #cbb99118, 0 1px 4px #ebc47b12',
        maxWidth: 1100,
      }}
    >
      <h2
        className="mb-2 fw-bold"
        style={{
          fontSize: '1.15rem',
          letterSpacing: '.02em',
          color: '#ad8b3a',
          fontFamily: 'Playfair Display, serif',
        }}
      >
        Raw Hair Bundles
      </h2>

      <div
        className="row justify-content-center"
        style={{ rowGap: '0.55rem', columnGap: '0.3rem' }}
      >
        {hairImages.map(({ src, alt, title, price }, idx) => (
          <div
            key={idx}
            className="col-4 col-md-3 col-lg-3 d-flex flex-column align-items-center"
            style={{ padding: 0, margin: '0 auto' }}
          >
            <div
              className="w-100"
              style={{
                cursor: 'pointer',
                background: '#fff',
                borderRadius: 8,
                boxShadow: '0 2px 6px #e3d3a619',
                padding: '0.45rem',
                transition: 'transform .12s, box-shadow .12s',
              }}
              onClick={() => navigate('/hair-price-list')}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px) scale(1.03)';
                e.currentTarget.style.boxShadow = '0 6px 16px #d9c48f18';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = '';
                e.currentTarget.style.boxShadow = '0 2px 6px #e3d3a619';
              }}
            >
              <img
                src={src}
                alt={alt}
                style={{
                  width: '100%',
                  height: 80,
                  objectFit: 'cover',
                  borderRadius: 5,
                  marginBottom: 4,
                }}
                onError={(e) => {
                  if (!e.target.dataset.fallback) {
                    e.target.dataset.fallback = 'true';
                    e.target.src = '/placeholder-image.jpg';
                  }
                }}
              />
              <div
                style={{
                  fontSize: '0.9em',
                  fontWeight: 600,
                  color: '#83612b',
                  textAlign: 'center',
                  fontFamily: 'Inter, sans-serif',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {title}
              </div>
              <div
                style={{
                  fontSize: '0.86em',
                  fontWeight: 600,
                  color: '#b27a24',
                  textAlign: 'center',
                  marginTop: 1,
                }}
              >
                {price}
              </div>
            </div>
          </div>
        ))}
      </div>

      <p
        style={{
          textAlign: 'center',
          fontSize: '.9rem',
          color: '#865f20',
          marginTop: '0.9rem',
          fontStyle: 'italic',
          fontWeight: 500,
          letterSpacing: '.01em',
        }}
      >
        📦 Raw hair bundles delivered within{' '}
        <span style={{ color: '#b8860b', fontWeight: 700 }}>2 weeks</span>
      </p>

      <button
        className="btn fw-bold rounded-pill px-4 py-2 mt-1"
        style={{
          background: 'linear-gradient(90deg, #c4a15a 0%, #d4c4a8 100%)',
          color: '#fff',
          border: 'none',
          fontSize: '.9rem',
          letterSpacing: '0.04em',
          fontFamily: 'Playfair Display, serif',
          boxShadow: '0 2px 6px #cab37212',
        }}
        onClick={() => navigate('/hair-price-list')}
      >
        View Full Price List
      </button>
    </section>
  );
};

export default HairShowcaseSection;
